/* eslint-disable @typescript-eslint/no-explicit-any */
import { useApiFetch } from '@/composables/useApiFetch'
// import { useGuestQuote } from '@/composables/useGuestQuote'
import { wrapGqlRequest } from '@/services/graphqlEndPointCommonSetting/wrapGqlRequest'

import type {
    AddToCartRequest,
    CartListItem,
    CartListResponse,
    CartTotalsResponse,
} from '@/types/cartAccs'

// const { getGuestQuoteId, setGuestQuoteId } = useGuestQuote()
export const useGuestCartAccsService = () => {
    const runtimeConfig = useRuntimeConfig() as {
        public?: {
            magentoApiUrl?: string
        }
    }
    const magentoApiUrl = runtimeConfig.public?.magentoApiUrl

    const createGuestCart = async (): Promise<{
        data: Ref<string | undefined>
        error: Ref<Error | null>
        pending: Ref<boolean>
    }> => {
        const data = ref<string | undefined>(undefined)
        const error = ref<Error | null>(null)
        const pending = ref<boolean>(true)

        const query = `
                mutation CreateGuestCart {
                createGuestCart(input: {}) {
                    cart {
                    id
                    }
                }
                }
            `
        try {
            const result = await wrapGqlRequest<{
                cart: { id: string }
            }>(query, {}, 'createGuestCart')

            data.value = result?.cart?.id
        } catch (err: any) {
            error.value = err
        } finally {
            pending.value = false
        }

        return { data, error, pending }
    }

    const fetchGuestCart = async (
        cartId: string
    ): Promise<{
        data: Ref<CartListResponse | undefined>
        error: Ref<Error | null>
        pending: Ref<boolean>
    }> => {
        const url = `${magentoApiUrl}/rest/V1/guest-carts/${cartId}`
        return useApiFetch<CartListResponse, Error>(url)
    }

    const addToGuestCart = async (
        payload: AddToCartRequest
    ): Promise<{
        data: Ref<CartListItem | undefined>
        error: Ref<Error | null>
        pending: Ref<boolean>
    }> => {
        // Holds GraphQL response mapped to CartListItem
        const data = ref<CartListItem | undefined>(undefined)

        // Stores any API or GraphQL error
        const error = ref<Error | null>(null)

        // Controls loading state during API call
        const pending = ref<boolean>(true)

        // Remove order_total because GraphQL does not need it in cartItems payload
        const { order_total, ...payloadToSend } = payload

        // Get current guest cart ID from Pinia store
        const { quoteId } = useGuestCartAccsStore()

        // GraphQL variables formatted for addProductsToCart mutation
        const variables = {
            cartId: quoteId,
            cartItems: [
                {
                    sku: payloadToSend.sku, // Product SKU
                    quantity: Number(payloadToSend.quantity) || 0, // Quantity as number
                    entered_options: payloadToSend.entered_options ?? [], // Custom options (designer project,builder id  etc.)
                },
            ],
        }

        // GraphQL mutation to add products to guest cart
        const mutation = `
                mutation AddProductsToCart($cartId: String!, $cartItems: [CartItemInput!]!) {
                    addProductsToCart(cartId: $cartId, cartItems: $cartItems) {
                        cart {
                            id
                            total_quantity
                        }
                        user_errors {
                            code
                            message
                        }
                    }
                }
`

        try {
            // Execute GraphQL mutation using shared wrapper
            const result = await wrapGqlRequest(mutation, variables, 'addProductsToCart')

            // Handle business-level GraphQL errors returned from Magento
            if (result?.user_errors?.length) {
                throw new Error(result.user_errors.map((e: any) => e.message).join(', '))
            }

            // Store GraphQL result in CartListItem format (keeps old flow intact)
            data.value = result as CartListItem
        } catch (err: any) {
            // Save error so UI / store can react
            error.value = err
        } finally {
            // Stop loading state once request finishes
            pending.value = false
        }

        // Return same structure as useApiFetch (no breaking change)
        return { data, error, pending }
    }

    const fetchCartTotal = async (
        quoteId: string
    ): Promise<{
        data: Ref<CartTotalsResponse | undefined>
        error: Ref<Error | null>
        pending: Ref<boolean>
    }> => {
        const url = `${magentoApiUrl}/rest/V1/guest-carts/${quoteId}/totals`
        return useApiFetch(url, { method: 'GET' })
    }

    // const removeDesignProjectFromCartApi = async (quoteId, itemId) => {
    //     const url = `${magentoApiUrl}/rest/V1/guest-carts/${quoteId}/items/${itemId}`
    //     const { data, error, pending, refresh } = await useApiFetch(url, {
    //         method: 'DELETE',
    //     })
    //     return { data, error, pending, refresh }
    // }

    // const addDesignProjectToCartApi = async (quoteId, cartPayLoad) => {
    //     const { sku, qty, price, productOption } = cartPayLoad

    //     const url = `${magentoApiUrl}/rest/V1/guest-carts/${quoteId}/items`

    //     const { data, error, pending, refresh } = await useApiFetch(url, {
    //         method: 'POST',
    //         body: {
    //             cartItem: {
    //                 quote_id: quoteId,
    //                 sku,
    //                 qty,
    //                 product_option: productOption,
    //             },
    //             order_total: price,
    //         },
    //     })
    //     return { data, error, pending, refresh }
    // }
    // code will be use in future to update cart
    /* const updateDesignProjectToCartApi = async (
        quoteId,
        { sku, qty, price, itemId, productOption }
    ) => {
        const runtimeConfig = useRuntimeConfig()
        const magentoApiUrl = runtimeConfig.public.magentoApiUrl

        const url = `${magentoApiUrl}/rest/V1/guest-carts/${quoteId}/items/${sku}`

        const { data, error, pending, refresh } = await useApiFetch(url, {
            method: 'PUT',
            body: {
                cartItem: {
                    quote_id: quoteId,
                    sku,
                    qty,
                    item_id: itemId,
                    product_option: productOption,
                },
                order_total: price,
            },
        })

        return { data, error, pending, refresh }
    } */

    return {
        // fetchGuestQuote,
        createGuestCart,
        fetchGuestCart,
        fetchCartTotal,
        addToGuestCart,
        //  updateDesignProjectToCartApi,
        // removeDesignProjectFromCartApi,
        // addDesignProjectToCartApi,
    }
}
